<template>
  <div>
    <div class="section text-center pb-0">
      <span class="ws-eyebrow">Contact</span>
      <h1 class="ws-h1 mt-3 mx-auto contact-title">Neem contact met ons op</h1>
      <p class="ws-lead mx-auto contact-intro">
        Heeft u een vraag, wilt u helpen of gebruikmaken van een verblijf? Laat
        het ons weten, dan reageren we zo snel mogelijk.
      </p>
    </div>

    <div class="formulier section pt-8" id="formulier">
      <div class="ws-card form ws-reveal" v-reveal>
        <v-img
          cover
          v-if="this.$vuetify.display.smAndUp"
          height="100%"
          class="form-img"
          alt=""
          src="https://images.pexels.com/photos/220455/pexels-photo-220455.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
        ></v-img>
        <div class="form-pad">
          <h2 class="form-heading">Contactformulier</h2>
          <p class="form-req">*verplicht</p>
          <div class="right">
            <v-text-field
              label="Uw naam *"
              variant="solo-filled"
              v-model="message.name"
              rounded="lg"
              flat
            ></v-text-field>
            <v-text-field
              label="Uw email adres *"
              variant="solo-filled"
              v-model="message.email"
              rounded="lg"
              flat
            ></v-text-field>
            <v-select
              v-model="message.subject"
              variant="solo-filled"
              label="Onderwerp *"
              rounded="lg"
              flat
              :items="items"
            ></v-select>
            <v-text-field
              label="Telefoonnummer"
              variant="solo-filled"
              v-model="message.phone"
              rounded="lg"
              flat
            ></v-text-field>

            <v-textarea
              hide-details
              v-model="message.message"
              label="Uw bericht *"
              variant="solo-filled"
              rounded="lg"
              flat
              style="grid-column-start: 1; grid-column-end: 3"
            ></v-textarea>
            <v-btn
              style="grid-column-start: 1; grid-column-end: 3"
              :color="sent ? 'green' : 'primary'"
              variant="flat"
              rounded="lg"
              block
              @click="sendMail"
              :readonly="sent"
              :disabled="
                !sent &&
                (!message.message ||
                  !message.email ||
                  !message.name ||
                  !message.subject)
              "
              :loading="sending"
              height="48"
              ><v-icon v-if="sent" class="mr-1" size="small" color="white"
                >mdi-check-circle</v-icon
              >{{ sent ? "Verzonden!" : "Verzenden" }}</v-btn
            >
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-center contact-info-wrap">
      <div class="ws-card formulier info-card ws-reveal" v-reveal>
        <div class="info-logos">
          <v-img
            height="90"
            width="90"
            :src="require('@/assets/logo.svg')"
            alt="WeShare4Kids logo"
            contain
          ></v-img>
          <v-img
            src="@/assets/anbi.svg"
            alt="ANBI keurmerk"
            width="90"
            height="90"
            contain
          ></v-img>
        </div>
        <div class="info-text">
          <h2 class="info-heading">Over de stichting</h2>
          <p class="ws-lead info-line">
            Adres: Van der Does de Willeboissingel 8, 5211 CA ’s-Hertogenbosch
          </p>
          <p class="ws-lead info-line">
            E-mail:
            <a href="mailto:info@weshare4kids.com" class="info-mail"
              >info@weshare4kids.com</a
            >
          </p>
          <p class="ws-lead info-line mb-0">
            Telefoon:
            <a href="tel:+31854828109" class="info-mail">085 4828109</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { collection, addDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { useMeta } from "vue-meta";

export default {
  setup() {
    useMeta({
      title: "Contact",
    });
  },
  data() {
    return {
      message: {
        name: "",
        subject: "",
        email: "",
        phone: "",
        message: "",
      },
      sending: false,
      sent: false,
      items: [
        "Ik (ons gezin) wil gebruik maken van een vakantieverblijf",
        "Ik wil mijn vakantieverblijf beschikbaar stellen",
        "Ik (ons bedrijf) wil partner worden",
        "Ik wil donateur worden",
        "Ik wil vrijwilliger worden",
        "Anders",
      ],
    };
  },
  methods: {
    async sendMail() {
      this.sending = true;
      await addDoc(collection(db, "mail"), {
        to: ["info@weshare4kids.com"],
        bcc: ["maxvankaathoven@gmail.com"],
        replyTo: this.message.email,
        message: {
          subject: `Nieuw contactformulier: ${this.message.subject}`,
          html: `<p>Onderwerp: ${this.message.subject}</p><p>Naam: ${this.message.name}</p><p>Email: ${this.message.email}</p><p>Telefoon: ${this.message.phone}</p><p>Bericht: ${this.message.message}</p>`,
        },
      });
      this.message = {
        name: "",
        subject: "",
        email: "",
        phone: "",
        message: "",
      };
      this.sending = false;
      this.sent = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-title {
  max-width: 700px;
}
.contact-intro {
  max-width: 520px;
  margin-top: 16px;
}

.formulier {
  max-width: 1000px;
  width: 70vw;
}
.form {
  display: grid;
  grid-template-columns: 45% auto;
  padding: 0;
  overflow: hidden;
}
.form-img {
  height: 100%;
}
.form-pad {
  padding: 38px 40px;
}
.form-heading {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 24px;
  color: #241b12;
}
.form-req {
  font-size: 12.5px;
  color: #8a7c6f;
  margin-bottom: 18px;
}
.right {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 18px;
  row-gap: 0;
}

.contact-info-wrap {
  margin-bottom: 100px;
}
.info-card {
  display: flex;
  flex-direction: row; /* override .ws-card's column so logos sit left of text */
  flex-wrap: wrap;
  align-items: center;
  gap: 28px;
  padding: 32px 38px;
}
.info-logos {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}
.info-text {
  flex: 1;
  min-width: 240px;
  padding-left: 28px;
  border-left: 1px solid rgba(42, 32, 24, 0.1);
}
.info-heading {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 20px;
  color: #241b12;
  margin-bottom: 6px;
}
.info-line {
  font-size: 15px;
  margin-bottom: 4px;
}
.info-mail {
  color: #c2541a;
  font-weight: 700;
}

@media screen and (max-width: 900px) {
  .form {
    grid-template-columns: 1fr;
  }
  .right {
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
  }
  .formulier {
    width: 90%;
  }
}

@media screen and (max-width: 600px) {
  .info-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 22px;
  }
  .info-text {
    min-width: 0;
    padding-left: 0;
    border-left: none;
  }
}
</style>
